module.exports = __webpack_public_path__ + "media/images/app_icons/android-icon-96x96-9d4d90b563cf97a8f31f7bf240313dc8.png";